import getAirports from "./getAirports";

export { getAirports };
